'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _isArray3 = require('lodash/isArray');

var _isArray4 = _interopRequireDefault(_isArray3);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _quicksend = require('redux/modules/quicksend');

var quickSendActions = _interopRequireWildcard(_quicksend);

var _components = require('components');

var _QuickSendForwardButton = require('./QuickSendForwardButton');

var _QuickSendForwardButton2 = _interopRequireDefault(_QuickSendForwardButton);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _projects = require('helpers/projects');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./QuickSendList.scss');

var QuickSendList = (_dec = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, quickSendActions, { pushState: _reactRouterRedux.push })), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(QuickSendList, _Component);

  function QuickSendList() {
    (0, _classCallCheck3.default)(this, QuickSendList);
    return (0, _possibleConstructorReturn3.default)(this, (QuickSendList.__proto__ || (0, _getPrototypeOf2.default)(QuickSendList)).apply(this, arguments));
  }

  (0, _createClass3.default)(QuickSendList, [{
    key: 'onForward',
    value: function onForward() {
      var _props = this.props,
          loadBox = _props.loadBox,
          boxType = _props.boxType;

      loadBox(boxType);
    }
  }, {
    key: 'openItem',
    value: function openItem(id) {
      var _props2 = this.props,
          pushState = _props2.pushState,
          boxType = _props2.boxType,
          toggleBoxView = _props2.toggleBoxView;

      toggleBoxView('item');
      pushState('/quick-send/' + boxType + '/' + id);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          items = _props3.items,
          boxType = _props3.boxType,
          activeId = _props3.activeId;

      var getRecipientsNames = function getRecipientsNames(recipients) {
        return (0, _isArray4.default)(recipients) ? recipients.map(function (recipient) {
          return recipient.fullName;
        }).join(', ') : '';
      };
      var isInboxType = boxType === _projects.quickSendBox.inbox;
      var isSentType = boxType === _projects.quickSendBox.sent;
      var isCanReply = function isCanReply(qsItem) {
        return isInboxType && !!qsItem.recipient_id;
      };

      return _react2.default.createElement(
        'div',
        { className: styles.list },
        items.map(function (item) {
          return _react2.default.createElement(
            'div',
            {
              className: (0, _classnames2.default)(styles.item, (0, _defineProperty3.default)({}, styles.active, activeId === item.projectId)),
              key: item.projectId,
              onClick: function onClick() {
                return _this2.openItem(item.projectId);
              }
            },
            isSentType && _react2.default.createElement(_QuickSendForwardButton2.default, {
              id: item.projectId,
              data: item,
              className: styles.forwardButton,
              iconClass: 'margin-right-5',
              onForward: _this2.onForward
            }),
            _react2.default.createElement(
              'div',
              { className: styles.title },
              item.subject || '———',
              isCanReply(item) && _react2.default.createElement(_components.QuickSendReplyButton, { contentKey: item.contentKey, senderName: item.owName })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.message },
              item.message
            ),
            _react2.default.createElement(
              'div',
              { className: styles.bottom },
              _react2.default.createElement(
                'div',
                { className: styles.date },
                item.sentDateText
              ),
              _react2.default.createElement(
                'div',
                { className: styles.sender },
                isInboxType ? item.owName : getRecipientsNames(item.recipients)
              )
            )
          );
        })
      );
    }
  }]);
  return QuickSendList;
}(_react.Component), _class3.propTypes = {
  activeId: _propTypes2.default.number,
  boxType: _propTypes2.default.string,
  items: _propTypes2.default.array,
  loadBox: _propTypes2.default.func,
  pushState: _propTypes2.default.func,
  toggleBoxView: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onForward', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onForward'), _class2.prototype)), _class2)) || _class);
exports.default = QuickSendList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/QuickSendList.js
// module id = 2075
// module chunks = 1